// State management hooks and utilities
import { useState } from "react";
import { apiService } from "./data";
import { toast } from "react-toastify";
import { t } from "i18next";

// Custom hook for managing comment functionality
export const useCommentManagement = (requestProgressId, onDataRefresh) => {
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [isViewCommentsModalOpen, setIsViewCommentsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [commentText, setCommentText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [popupMenuOpen, setPopupMenuOpen] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const handleCommentIconClick = (row, event) => {
    const rect = event.target.getBoundingClientRect();
    setPopupPosition({
      x: rect.left + rect.width + 10,
      y: rect.top
    });
    setSelectedRow(row);
    setPopupMenuOpen(row.id);
  };

  const handleViewComments = () => {
    // Comments are already available in selectedRow.comments
    setIsViewCommentsModalOpen(true);
    setPopupMenuOpen(null);
  };

  const handleAddCommentClick = () => {
    setIsCommentModalOpen(true);
    setPopupMenuOpen(null);
  };

  const handleCommentSubmit = async () => {
    if (selectedRow && commentText.trim() && requestProgressId) {
      try {
        let submissionResponse = await apiService.submitComment(selectedRow.id, requestProgressId, commentText, selectedFile);
        if(submissionResponse){
            toast.success(t("Comment Saved Successfully!"), { position: "top-center" });
            
            // After successful comment submission, call switch-progress API with action sendback to "committee"
            // try {
            //   await apiService.switchToCommittee(requestProgressId);
            //   toast.success(t("Sent to Committee Review Successfully!"), { position: "top-center" });
            // } catch (switchError) {
            //   console.error("Error switching to committee:", switchError);
            //   toast.error(t("Failed to send to committee review"), { position: "top-center" });
            // }
        } else {
            toast.error(t("Failed to save comment"), { position: "top-center" });
        }
        setIsCommentModalOpen(false);
        setCommentText("");
        setSelectedFile(null);
        setSelectedRow(null);
        
        // Refresh data to show the new comment
        if (onDataRefresh) {
          onDataRefresh();
        }
      } catch (error) {
        console.error("Error submitting comment:", error);
        toast.error(t("Failed to save comment"), { position: "top-center" });
      }
    }
  };

  const closePopup = () => {
    setPopupMenuOpen(null);
  };

  const closeCommentModal = () => {
    setIsCommentModalOpen(false);
    setCommentText("");
    setSelectedFile(null);
  };

  const closeViewCommentsModal = () => {
    setIsViewCommentsModalOpen(false);
  };

  return {
    // State
    isCommentModalOpen,
    isViewCommentsModalOpen,
    selectedRow,
    commentText,
    selectedFile,
    popupMenuOpen,
    popupPosition,
    
    // Actions
    handleCommentIconClick,
    handleViewComments,
    handleAddCommentClick,
    handleCommentSubmit,
    closePopup,
    closeCommentModal,
    closeViewCommentsModal,
    setCommentText,
    setSelectedFile
  };
};

// Custom hook for managing action buttons
export const useActionButtons = (requestProgressId) => {
  const handleAction = async (action) => {
    try {
      // Single action submission - no multi-row selection
      await apiService.submitReview(requestProgressId, action);
      console.log(`${action} action submitted successfully`);
    } catch (error) {
      console.error(`Error submitting ${action}:`, error);
    }
  };

  return {
    handleApprove: () => handleAction("approved"),
    handleReject: () => handleAction("rejected"),
    handleSendBack: () => handleAction("sendback")
  };
};

export const shouldClosePopup = (event) => {
  return !event.target.closest('.popup-menu') && !event.target.closest('button');
};
